import { IListItem, INewDonorRecipientBaseData } from '@nkr/models/index';

export enum TypeOption {
    Select = 0,
    DonorOnlyNdd = 1,
    DonorOnlyFv = 2,
    DonorOnlySv = 3,
    PairSv = 4,
    PairPd = 5,
    PairRd = 6,
    PairNkrId = 7,
    PatientOnly = 8,
}

export enum PatientSelection {
    NewPatient = 1,
    ExistingPatient = 2
}

export const NewMedicalRecord = -1;

export interface IBaseDataValidation {
    alias: boolean,
    mrn: boolean,
    gender: boolean,
    dateOfBirth: boolean,
    email: boolean,
    phoneNumber: boolean,
    firstName: boolean,
    lastName: boolean,
    bloodType: boolean,
    hasNutcracker: boolean,
    address: boolean,
    city: boolean,
    state: boolean,
    postalCode: boolean,
    existingAlias: boolean,
    existingMrn: boolean,
    shipTypingSwabs: boolean,
    medicalRecord: boolean
}

export const initialDonorDetails: INewDonorRecipientBaseData = {
    alias: __ENVIRONMENT__ == 'dev' ? 'NEWDONOR01' : '',
    mrn: __ENVIRONMENT__ == 'dev' ? 'MRN01D' : '',
    gender: __ENVIRONMENT__ == 'dev' ? 'M' : '',
    dateOfBirth: __ENVIRONMENT__ == 'dev' ? '01/01/2001' : '',
    email: __ENVIRONMENT__ == 'dev' ? 'new_donor_01@me.com' : '',
    phoneNumber: __ENVIRONMENT__ == 'dev' ? '2035551212' : '',
    firstName: __ENVIRONMENT__ == 'dev' ? 'New' : '',
    lastName: __ENVIRONMENT__ == 'dev' ? 'Donor' : '',
    bloodType: __ENVIRONMENT__ == 'dev' ? 'O' : '',
    hasNutcracker: null,
    address: __ENVIRONMENT__ == 'dev' ? 'Main St' : '',
    city: __ENVIRONMENT__ == 'dev' ? 'New York' : '',
    state: __ENVIRONMENT__ == 'dev' ? 'NY' : '',
    postalCode: __ENVIRONMENT__ == 'dev' ? '10001' : '',
    shipTypingSwabs: -1,
    sendSelfRegistrationInvite: -1,
    medicalRecordId: 0
}

export const initialRecipientDetails: INewDonorRecipientBaseData = {
    alias: __ENVIRONMENT__ == 'dev' ? 'NEWRECIPIENT01' : '',
    mrn: __ENVIRONMENT__ == 'dev' ? 'MRN01R' : '',
    gender: __ENVIRONMENT__ == 'dev' ? 'F' : '',
    dateOfBirth: __ENVIRONMENT__ == 'dev' ? '02/02/2002' : '',
    email: __ENVIRONMENT__ == 'dev' ? 'new_recipient_01@me.com' : '',
    phoneNumber: __ENVIRONMENT__ == 'dev' ? '2125551212' : '',
    firstName: __ENVIRONMENT__ == 'dev' ? 'New' : '',
    lastName: __ENVIRONMENT__ == 'dev' ? 'Recipient' : '',
    bloodType: __ENVIRONMENT__ == 'dev' ? 'B' : '',
    hasNutcracker: null,
    address: __ENVIRONMENT__ == 'dev' ? 'Summer St' : '',
    city: __ENVIRONMENT__ == 'dev' ? 'Stamford' : '',
    state: __ENVIRONMENT__ == 'dev' ? 'CT' : '',
    postalCode: __ENVIRONMENT__ == 'dev' ? '06901' : '',
    shipTypingSwabs: -1,
    sendSelfRegistrationInvite: -1,
    medicalRecordId: 0
}

export const initialValidation: IBaseDataValidation = {
    alias: true,
    mrn: true,
    gender: true,
    dateOfBirth: true,
    email: true,
    phoneNumber: true,
    firstName: true,
    lastName: true,
    bloodType: true,
    hasNutcracker: true,
    address: true,
    city: true,
    state: true,
    postalCode: true,
    existingAlias: false,
    existingMrn: false,
    shipTypingSwabs: true,
    medicalRecord: true
};

export const typeOptionList: IListItem[] = [
    { id: TypeOption.DonorOnlyNdd, description: 'Donor Only - Non-Directed' },
    { id: TypeOption.DonorOnlyFv, description: 'Donor Only - Family Voucher' },
    { id: TypeOption.DonorOnlySv, description: 'Donor Only - Standard Voucher' },
    // { id: TypeOption.PairSv, description: 'Pair - Standard Voucher' },
    { id: TypeOption.PairPd, description: 'Pair - Paired Donation' },
    // { id: TypeOption.PairRd, description: 'Pair - Remote Direct' },
    // { id: TypeOption.PairNkrId, description: 'Pair - NKR Internal Direct' },
    { id: TypeOption.PatientOnly, description: 'Recipient Only - Waitlist Patient' },
];

